






















































































import AbpBase from "@/lib/abpbase";
import { Component, Watch, Prop,vue } from "vue-property-decorator";
import PdEducationPlanStepAdd from "./pdEducationPlanStepAdd.vue";
import PdEducationPlanDetailAdd from "./pdEducationPlanDetailAdd.vue";
import {
  getPlanStepList,
  getPlanStepDetailList,
  DeletePlanStep,
  DeletePlanStepDetail,
  SaveEducationPlanStepDetail
} from "@/api/pdEducationPlan/pdEducationPlan";
@Component({
  components: {
    PdEducationPlanStepAdd,
    PdEducationPlanDetailAdd
  }
})
export default class PdEducationPlanStep extends AbpBase {
  @Prop() pdEducationPlan: any;
  @Prop({ type: Boolean, default: false }) value: boolean;
  split1 = 0.5;
  loading: boolean = false;
  detailLoading: boolean = false;
  currentPlan: any = {};
  currentPlanDetail: any = {};
  showPlan: boolean = false;
  showPlanDetail: boolean = false;
  response: any = {};
  detailResponse: any = {};
  EducationPlan: any = {};
  payload = {
    PD_Plan_ID: 0,
    SkipCount: 1,
    MaxResultCount: 10
  };
  detailPayload = {
    PD_Step_ID: 0,
    SkipCount: 1,
    MaxResultCount: 10
  };
  columns = [
    {
      title: "步骤名称",
      key: "titile",
      minWidth: 150
    },
    {
      title: "计划后多少天",
      key: "afterDays",
      minWidth: 180
    },
    {
      title: "步骤说明",
      key: "description",
      minWidth: 180
    },
    {
      title: "操作",
      key: "",
      minWidth: 130,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "success", icon: "ios-create", size: "small" },
            style: { marginRight: "5px" },
            on: {
              click: () => {
                this.handleUpdatePlan(p.row);
              }
            }
          }),
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            on: {
              click: () => {
                this.handleDeletePlan(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];
  detailColumns = [
    {
      title: "材料名称",
      key: "knowName",
      minWidth: 120
    },
    {
      title: "说明",
      key: "knowText",
      minWidth: 200
    },
    {
      title: "操作",
      key: "",
      minWidth: 150,
      render: (h: any, p: any) => {
        return h("div", [
          h("Button", {
            props: { type: "error", icon: "ios-trash", size: "small" },
            on: {
              click: () => {
                this.handleDeletePlanDetail(p.row.id);
              }
            }
          })
        ]);
      }
    }
  ];

  created() {
    if (this.pdEducationPlan) {
      this.EducationPlan = this.pdEducationPlan;
    }
    this.detailResponse = {};
    this.getPlanList();
  }

  handleUpdatePlan(row: any) {
    this.currentPlan = Object.assign({}, row);
    this.showPlan = true;
  }

  handleDeletePlan(id: number) {
    this.$confirm("确定要删除吗？", "提示").then(async () => {
      await DeletePlanStep(id);
      this.getPlanList();
      this.getPlanDetailList();
    });
  }

  handleAddPlan() {
    this.currentPlan = {
      id: 0,
      PD_Plan_ID: this.EducationPlan.id
    };
    this.showPlan = true;
  }

  handleUpdatePlanDetail(row: any) {
    this.currentPlanDetail = Object.assign({}, row);
    this.showPlanDetail = true;
  }

  handleDeletePlanDetail(id: number) {
    this.$confirm("确定要删除吗？", "提示").then(async () => {
      await DeletePlanStepDetail(id);
      this.getPlanDetailList();
    });
  }

  handleAddPlanDetail() {
    if (!this.currentPlan.id) {
      this.$Message.error("请选择一个宣教步骤");
      return;
    }

    this.currentPlanDetail = {
      id: 0,
      PD_Step_ID: this.currentPlan.id
    };
    this.showPlanDetail = true;
  }

  handlePlanPageChange(val: any) {
    this.payload.SkipCount = val;
    this.getPlanList();
  }

  handlePlanDetailPageChange(val: any) {
    this.detailPayload.SkipCount = val;
    this.getPlanDetailList();
  }

  handlePlanAddOk() {
    this.$refs.PdEducationPlanStepAdd.submit().then(res => {
      if (res) {
        this.showPlan = false;
        this.getPlanList();
      }
    });
  }

  async handlePlanDetailAddOk() {
    this.showPlanDetail = false;
    let res = this.$refs.PdEducationPlanDetailAdd.onSubmit();
    //提交数据
    let requestData = {
      PD_Step_ID: this.currentPlan.id,
      KnowledgeList: res
    };
    this.loading = true;
    await SaveEducationPlanStepDetail(requestData);
    this.loading = false;
    this.getPlanDetailList();
  }

  handlePlanAddVisibleChange(res: any) {
    if (!res) {
      this.$refs.PdEducationPlanStepAdd.resetForm();
    }
  }

  handlePlanClick(row: any, index: any) {
    this.currentPlan = row;
    this.getPlanDetailList();
  }

  async getPlanList() {
    this.loading = true;
    this.payload.PD_Plan_ID = this.EducationPlan.id;
    let res = await getPlanStepList(this.payload);
    this.response = res.data;
    this.loading = false;
  }

  async getPlanDetailList() {
    if (this.currentPlan.id) {
      this.detailLoading = true;
      this.detailPayload.PD_Step_ID = this.currentPlan.id;
      let res = await getPlanStepDetailList(this.detailPayload);
      this.detailResponse = res.data;
      this.detailLoading = false;
    }
  }
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdEducationPlan/parts/pdEducationPlan/pdEducationPlanStep.vue